import { render, staticRenderFns } from "./Mikepad.vue?vue&type=template&id=61c61d56&scoped=true&"
import script from "./Mikepad.vue?vue&type=script&lang=js&"
export * from "./Mikepad.vue?vue&type=script&lang=js&"
import style0 from "./Mikepad.vue?vue&type=style&index=0&id=61c61d56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c61d56",
  null
  
)

export default component.exports